// extracted by mini-css-extract-plugin
export var alertIcon = "_s7-0";